import { ICreateSendCustomMessagePatch } from '../../../types/createSendCustomMessage';

export const PATCH_CS_CUSTOM_MESSAGE = 'PATCH_CS_CUSTOM_MESSAGE';
export const RESET_CS_CUSTOM_MESSAGE = 'RESET_CS_CUSTOM_MESSAGE';

export const patchCsCustomMessage = (payload: ICreateSendCustomMessagePatch) => ({
  type: PATCH_CS_CUSTOM_MESSAGE,
  payload,
});

export const resetCsCustomMessage = () => ({
  type: RESET_CS_CUSTOM_MESSAGE,
});
